import { defineAsyncComponent } from 'vue'

export const ModalGetTheApp = defineAsyncComponent(() => import('../ModalGetTheApp/ModalGetTheApp.vue'))
